"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgRulerFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M4 20a2 2 0 002 2h3a2 2 0 002-2V4a2 2 0 00-2-2H6a2 2 0 00-2 2v16zm6-15H7v1h3V5zm0 2H8v1h2V7zm0 2H7v1h3V9zm0 2H8v1h2v-1zm0 2H7v1h3v-1zm0 2H8v1h2v-1zm0 2H7v1h3v-1zm0 2H8v1h2v-1z' }),
    react_1.default.createElement("path", { d: 'M19 2h-6v2h2v16h-2v2h6v-2h-2V4h2V2z' }))); };
exports.default = SvgRulerFilled;
//# sourceMappingURL=RulerFilled.js.map